"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableProject = exports.TablePlacePageHeader = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const PlaceHeaderMetadataProject_1 = require("../placePage/PlaceHeaderMetadataProject");
const PlaceHeaderMetadataTableauUser_1 = require("../placePage/PlaceHeaderMetadataTableauUser");
const PlacePageIconContainer_1 = require("../placePage/PlacePageIconContainer");
const TablesDisplayPlacePageData_1 = require("../table/types/TablesDisplayPlacePageData");
const CreateWorkbookFromCatalogButtons_1 = require("./CreateWorkbookFromCatalogButtons");
function TablePlacePageHeader(props) {
    const featureFlags = (0, catalog_core_1.useFeatureFlags)();
    const uiActions = (0, catalog_core_1.useUIActions)();
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const apiRequests = (0, catalog_core_1.useApiRequests)();
    const editingIsEnabled = apiRequests.isSiteCreatorOrHigher() && !props.hideLaunchEditOnMobile;
    const canCreateFlowFromTable = editingIsEnabled && !!props.newFlowFromCatalog;
    const dbclass = props.table && props.table.database && props.table.database.connectionType;
    const sendCreateEvent = (0, data_catalog_shared_1.useTelemetrySender)({
        type: '',
        content_type: '',
        data_type: '',
        connection_type: '',
    });
    return (react_1.default.createElement(data_catalog_shared_1.PlacePageHeader, null,
        react_1.default.createElement(data_catalog_shared_1.PlacePageTitleContainer, null,
            react_1.default.createElement(PlacePageIconContainer_1.PlacePageIconContainer, { title: catalog_messages_1.Messages.Table() },
                react_1.default.createElement(data_catalog_shared_1.TableMastheadIcon, null)),
            react_1.default.createElement(data_catalog_shared_1.PlacePageMastheadContainer, null,
                react_1.default.createElement(data_catalog_shared_1.PlacePageMastheadRowContainer, null,
                    react_1.default.createElement(data_catalog_shared_1.PlacePageTitle, { title: props.table.name || undefined }, props.table.name),
                    react_1.default.createElement(data_catalog_shared_1.PlacePageActionsMenu, null, uiActions.renderTablesActionMenu(props.table))),
                react_1.default.createElement(data_catalog_shared_1.PlacePageMastheadRowContainer, null,
                    react_1.default.createElement(TableContact, { table: props.table }),
                    featureFlags.databasesInProjectsEnabled && react_1.default.createElement(TableProject, { table: props.table }),
                    react_1.default.createElement(LabelsHookHelper_1.LabelWrapper, { itemInfo: props.table, isEager: true, kind: 'chip', wrapper: (e) => react_1.default.createElement(data_catalog_shared_1.HeaderLabelChipStyle, null, e) })))),
        react_1.default.createElement(CreateWorkbookFromCatalogButtons_1.CreateDocumentFromResourceButton, { apiRequests: apiRequests, siteUrls: siteUrls, isEmbedded: !!props.table.isEmbedded, resourceId: props.table.id, resourceType: CreateWorkbookFromCatalogButtons_1.RESOURCE_TYPE_TABLE, databaseClass: dbclass, title: catalog_messages_1.Messages.NewWorkbookButton(), canCreateWorkbook: editingIsEnabled, canCreateFlow: canCreateFlowFromTable, projectIdForNewDocuments: props.projectIdForNewDocuments, sendCreateDocumentEvent: sendCreateEvent })));
}
exports.TablePlacePageHeader = TablePlacePageHeader;
function TableContact(props) {
    const contact = (0, TablesDisplayPlacePageData_1.isCatalogTableType)(props.table) ? props.table.contact : null;
    return (react_1.default.createElement(data_catalog_shared_1.PlaceHeaderMetadataItem, null,
        react_1.default.createElement(PlaceHeaderMetadataTableauUser_1.PlaceHeaderMetadataTableauUser, { tableauUser: contact, labelText: catalog_messages_1.Messages.GridHeaderContact() })));
}
function TableProject(props) {
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const apiRequests = (0, catalog_core_1.useApiRequests)();
    const [container, setContainer] = react_1.default.useState();
    react_1.default.useEffect(() => {
        apiRequests
            .getContainerForContent({ contentType: 'table', contentId: props.table.vizportalId })
            .then(container => setContainer(container))
            .catch(() => setContainer(undefined));
    }, [props.table, apiRequests]);
    return (container && container.type === 'PROJECT')
        ? (react_1.default.createElement(data_catalog_shared_1.PlaceHeaderMetadataItem, null,
            react_1.default.createElement(PlaceHeaderMetadataProject_1.PlaceHeaderMetadataProject, { projectId: container.id, projectName: container.name, siteUrls: siteUrls })))
        : null;
}
exports.TableProject = TableProject;
//# sourceMappingURL=TablePlacePageHeader.js.map